import { DashboardSidebar } from '../components/DashboardSidebar';
import type { SidebarMode } from '../components/DashboardSidebar';

interface DashboardShellProps {
  mode: SidebarMode;
  eventId?: string;
  children: React.ReactNode;
}

export function DashboardShell({ mode, eventId, children }: DashboardShellProps) {
  return (
    // font-dash (Inter) só se aplica aqui dentro — o site público mantém Quicksand/Atkinson.
    // Sidebar e nav (header de cada tela) são a "moldura" — mesma cor (bg-secondary), sem linha
    // entre os dois. O cartão que muda de cor é só a área rolável abaixo do header (o "hero"),
    // que cada tela pinta com bg-background + borda arredondada no canto superior esquerdo,
    // exatamente no ponto onde sidebar e nav se encontram.
    <div className="flex h-dvh w-full overflow-hidden bg-secondary text-foreground font-dash">
      <DashboardSidebar mode={mode} eventId={eventId} />
      <div className="flex-1 flex flex-col min-w-0 h-dvh">
        {children}
      </div>
    </div>
  );
}
